import { FC } from 'react';
import { IPopularCollection } from '@modules/collections/domain/models/popularCollection.model';
import PopularCollectionCard from './popularCollectionCard/PopularCollectionCard';
import { CardContainer, Container } from './PopularCollectionLayout.style';
interface Props {
  collectionList: IPopularCollection[];
}
const PopularCollectionLayout: FC<Props> = ({
  collectionList
}: Props) => {
  return <Container>
            <CardContainer>
                {collectionList?.map(collection => <PopularCollectionCard key={collection.id} id={collection.id} menuAmount={collection.menuAmount} menuAmountColor={collection.menuAmountColor} name={collection.name} nameColor={collection.nameColor} backgroundImage={collection.backgroundImage} recipeList={collection.recipeList} />)}
            </CardContainer>
        </Container>;
};
export default PopularCollectionLayout;